export default __webpack_public_path__ + "static/media/blurCourses2.e4f3a6fb.png";